import { cx } from '@/styles/muiTheme';

/**
 * Hue for a `game.status` badge.
 *
 * The exact colors the solid Chip in the games table used — only the badge shape
 * changed. Shared so Manage Games and the Simulive table cannot drift: both
 * render the same `game.status` field from the same /v1.0/games route, and the
 * scheduler flips recorded -> live underneath them.
 */
export const getGameStatusColor = (status: string) => {
  switch (status) {
    case 'scheduled':
      return '#7FA748';
    case 'live':
      return '#f05d5e';
    case 'recorded':
      return '#e3b505';
    default:
      // Was the Chip's `'default'` keyword for its neutral grey. StatusBadge
      // derives its fill and ring with alpha(), which throws on keywords, so
      // this is the explicit hue that keyword resolved to.
      return cx.text.muted;
  }
};
